import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Typography, withStyles } from '@material-ui/core';
import SubTitle from '../components/Text/SubTitle';

const styles = (theme) => ({
  body: {
    fontSize: '1.3em',
    lineHeight: 1.8,
    '& span': {
      // color: 'red',
      fontWeight: 'bold',
    },
  },

  importantDatesDiv: {
    // borderRadius: 0,
    color: '#fff',
    // boxShadow: 'none',
    padding: theme.spacing(4, 5),
  },
  importantDatesDate: {
    fontWeight: 'bold',
    fontSize: '1.6em',
  },
  importantDatesTitle: {
    fontSize: '1.2em',
  },

  stepsDiv: {
    display: 'flex',
  },
  stepItem: {
    width: '20%',
  },
  stepsNo: {
    fontSize: '1.2em',
    color: '#7d889a',
    '& span': {
      fontSize: '1.2em',
      fontWeight: 'bold',
    },
  },
  stepContent: {
    padding: theme.spacing(3, 4),
    color: '#fff',
    height: '120px',
  },

  topicTitle: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '1.2em',
    marginBottom: '0.5em',
  },
  topicContents: {
    '& p': {
      paddingLeft: 8,
      textIndent: -8,
    },
  },

  orderedList: {
    '& li': { marginBottom: '.5rem', fontWeight: 500, fontSize: '1.2em', lineHeight: 1.6 },
    '& span': {
      color: 'red',
      fontWeight: 'bold',
    },
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    color: '#000000',
    '& th': { textAlign: 'center', fontWeight: 'bold', fontSize: 'large' },
    '& td': {
      fontWeight: 500,
      fontSize: 'large',
      '& p': {
        textIndent: '-0.65em',
        paddingLeft: '0.6em',
      },
    },
    // '&:nth-of-type(odd)': {
    //   '& th': {
    //     backgroundColor: '#cfdae6',
    //   },
    //   '& td': {
    //     backgroundColor: '#e6edf6',
    //   },
    // },
    // '&:nth-of-type(even)': {
    //   '& th': {
    //     backgroundColor: '#e9eff5',
    //   },
    //   '& td': {
    //     backgroundColor: '#f4f7fa',
    //   },
    // },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  root: {
    border: '2px solid',
    borderColor: '#fff',
    fontSize: '1.2em',
    fontWeight: 500,
    // padding: '8px 0',
    backgroundColor: '#e9eef1',
  },
}))(TableCell);

class RegistrationGuideEn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:600px)').matches,
    };

    this.stepNoRef = React.createRef();
    this.stepContentRef = React.createRef();
  }

  componentDidMount() {
    for (let i = 1; i <= 5; i++) {
      document.getElementById(`steps-content-${i}`).style.height = `${document.getElementById(`steps-content-1`).scrollHeight}px`;
    }
  }

  registrationProcess() {
    const { classes } = this.props;
    const STEPS = [
      {
        no: 1,
        color: '#7d889a',
        bgColor: 'rgba(125,136,154, 0.1)',
        title: 'STEP 01',
        content: 'Sign-up 또는 Log in 클릭',
      },
      {
        no: 2,
        color: '#265c7a',
        bgColor: 'rgba(38, 92, 122, 0.1)',
        title: 'STEP 02',
        content: '개인 정보 입력 후 등록 카테고리 선택',
      },
      {
        no: 3,
        color: '#0c7282',
        bgColor: 'rgba(12,114,130, 0.1)',
        title: 'STEP 03',
        content: '결제방법 선택 및 결제',
      },
      {
        no: 4,
        color: '#7fb46d',
        bgColor: 'rgba(127,180,109, 0.1)',
        title: 'STEP 04',
        content: '등록(결제) 완료 메일 확인',
      },
      {
        no: 5,
        color: '#d0d24d',
        bgColor: 'rgba(216,223,86, 0.1)',
        title: 'STEP 05',
        content: '완료',
      },
    ];

    return (
      <div className={classes.stepsDiv}>
        {STEPS.map((step, idx) => (
          <div key={`step-for-submission-${idx}`} className={classes.stepItem}>
            <div
              className={classes.stepsNo}
              style={{
                backgroundColor: step.bgColor,
                position: 'relative',
                padding: this.props.theme.spacing(2, 0),
                display: 'flex',
                alignItems: 'baseline',
              }}
              id={`steps-no-${idx + 1}`}
            >
              <p style={{ backgroundColor: step.color, width: '1em', height: '0.3em', position: 'absolute', bottom: '20%', left: 0 }} />
              <div style={{ marginLeft: 20 }}>
                Step <span style={{ color: step.color }}>0{idx + 1}</span>
              </div>
            </div>
            <div
              className={classes.stepContent}
              style={{ backgroundColor: step.color, height: 'auto !important', textAlign: 'center' }}
              id={`steps-content-${idx + 1}`}
            >
              <Typography
                dangerouslySetInnerHTML={{ __html: step.content }}
                style={{ fontSize: '1.2em', fontWeight: 'bold', marginTop: '0.5em', wordBreak: 'keep-all' }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const { classes, theme, parent } = this.props;
    return (
      <React.Fragment>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <SubTitle>Guideline</SubTitle>
          </div>
          <Grid container direction="row" alignItems="center" justifyContent={'space-between'}>
            <Typography className={classes.body}>
              모든 참가자는 PRS KOREA 2022 온라인 등록 시스템을 통해 등록해야 하며 사전등록 마감일 전까지 등록 부탁드립니다.&nbsp;
              <br />
              (사전등록 마감일인 10월 31일까지 사전등록을 완료하지 못하신 분들은 현장 등록데스크에서 현장등록 가능합니다.)
              {/* <span style={{ color: 'red' }}>(2021년 10월 29일(금) 23:59까지)</span> */}
              <br />
              <b style={{ color: '#f00' }}>
                *PRS KOREA 2022 사전등록을 위해서 하단의 Sign-up을 먼저 해 주시기 바랍니다. (Sign-up 없이 사전등록은 불가합니다.)
              </b>
            </Typography>
            <Grid />
          </Grid>
          <Grid container style={{ paddingTop: 20 }}>
            <Grid container justifyContent="center">
              <Grid container justifyContent="center">
                <Button
                  variant="contained"
                  // color="primary"
                  // disableElevation
                  onClick={() => parent.history.push('/choose')}
                  style={{
                    borderRadius: '5px',
                    backgroundColor: this.props.theme.palette.secondary.main,
                    color: '#fff',
                    fontSize: '1.4em',
                    fontWeight: 'bold',
                    padding: '1em 0',
                    textTransform: 'none',
                    width: '300px',
                    marginRight: 20,
                  }}
                  // startIcon={<FaFileUpload size={30} />}
                >
                  Sign-up 바로가기
                </Button>{' '}
                <Button
                  variant="contained"
                  // color="primary"
                  // disableElevation
                  onClick={() => parent.history.push('/registration/submission')}
                  style={{
                    borderRadius: '5px',
                    backgroundColor: this.props.theme.palette.primary.main,
                    color: '#fff',
                    fontSize: '1.4em',
                    fontWeight: 'bold',
                    padding: '1em 0',
                    textTransform: 'none',
                    width: '300px',
                    marginLeft: 20,
                  }}
                  // startIcon={<FaFileUpload size={30} />}
                >
                  사전등록 바로가기
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {/* <div style={{ textAlign: 'center', marginTop: '1em' }}>
            <Button
              variant="contained"
              // color="primary"
              // disableElevation
              onClick={() => parent.history.push('/registration/submission')}
              style={{
                borderRadius: '5px',
                backgroundColor: this.props.theme.palette.primary.main,
                color: '#fff',
                fontSize: '1.4em',
                fontWeight: 'bold',
                padding: '1em 0',
                textTransform: 'none',
                width: '300px',
              }}
              // startIcon={<FaFileUpload size={30} />}
            >
              사전등록 바로가기
            </Button>
          </div> */}
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Important Dates</SubTitle>
          <Grid container direction="row" spacing={2}>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#7d889a', borderRadius: '5px' }}>
                <Typography className={classes.importantDatesTitle}>조기등록 마감일</Typography>
                <Typography className={classes.importantDatesDate}>2022년 9월 16일 (금)</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#237a9d', borderRadius: '5px' }}>
                <Typography className={classes.importantDatesTitle}>발표자 등록 마감일</Typography>
                <Typography className={classes.importantDatesDate}>2022년 10월 31일 (월)</Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.importantDatesDiv} style={{ backgroundColor: '#164273', borderRadius: '5px' }}>
                <Typography className={classes.importantDatesTitle}>사전등록 마감일</Typography>
                <Typography className={classes.importantDatesDate}>2022년 10월 31일 (월)</Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Registration Process</SubTitle>
          {this.registrationProcess()}
        </div>
        <div>
          <div style={{ height: '50px' }} />
        </div>
        <div>
          <SubTitle>Registration Fees</SubTitle>
          {/* <Typography style={{ fontWeight: 'bold', paddingBottom: 10 }}>Korean</Typography> */}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    backgroundColor: '#237a9d',
                    borderRight: '1px solid #fff',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: '1.2em',
                    textAlign: 'center',
                    padding: 8,
                  }}
                >
                  등록구분
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#237a9d',
                    borderRight: '1px solid #fff',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: '1.2em',
                    textAlign: 'center',
                    padding: 8,
                  }}
                >
                  조기등록
                  <br />
                  (9월 16일까지)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#237a9d',
                    borderRight: '1px solid #fff',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: '1.2em',
                    textAlign: 'center',
                    padding: 8,
                  }}
                >
                  사전등록
                  <br />
                  (9월 17일~10월 31일까지)
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: '#237a9d',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: '1.2em',
                    textAlign: 'center',
                    padding: 8,
                  }}
                >
                  당일등록
                  <br />
                  (11월 11일~13일)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="center">정회원</StyledTableCell>
                <StyledTableCell align="center">KRW 300,000</StyledTableCell>
                <StyledTableCell align="center">KRW 350,000</StyledTableCell>
                <StyledTableCell align="center">KRW 400,000</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">군의관・공보의</StyledTableCell>
                <StyledTableCell align="center">KRW 200,000</StyledTableCell>
                <StyledTableCell align="center">KRW 250,000</StyledTableCell>
                <StyledTableCell align="center">KRW 300,000</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">전공의・국내연수 외국인의사</StyledTableCell>
                <StyledTableCell align="center">KRW 150,000</StyledTableCell>
                <StyledTableCell align="center">KRW 170,000</StyledTableCell>
                <StyledTableCell align="center">KRW 200,000</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">동반자</StyledTableCell>
                <StyledTableCell align="center">KRW 150,000</StyledTableCell>
                <StyledTableCell align="center">KRW 170,000</StyledTableCell>
                <StyledTableCell align="center">KRW 200,000</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </div>
        <div>
          <div style={{ height: '30px' }} />
        </div>
        <div>
          <SubTitle>Payment Method</SubTitle>
          <span className={classes.orderedList} style={{ fontSize: '1.2em' }}>
            등록비 납부여부는 'My Page'에서 확인하실 수 있으며, 등록비는 아래 2가지 방법 중 하나를 선택하여 납부하실 수 있습니다.
          </span>
          <div>
            <div style={{ height: '20px' }} />
          </div>
          <Typography style={{ fontWeight: 'bold' }}>1) 신용카드</Typography>
          <div style={{ color: '#000000' }}>
            <ul className={classes.orderedList}>
              <li>신용카드 결제는 온라인 등록 시스템을 통해서만 가능합니다.</li>
              {/* <li>모든 신용카드 서비스 요금은 등록자가 부담해야 합니다.</li> */}
              <li>
                신용카드 영수증의 가맹점 명은 <span style={{ color: 'red' }}>'Eximbay' (해외) 또는 ‘Easy Pay’ (국내) </span> 입니다.
              </li>
            </ul>
          </div>
          <Typography style={{ fontWeight: 'bold' }}>2) 무통장 입금</Typography>
          <div style={{ color: '#000000' }}>
            <ul className={classes.orderedList}>
              <li>계좌이체의 경우, 아래 계좌로 등록비 입금 해야 하며, 송금에 대한 모든 은행 수수료는 등록자가 부담해야 합니다.</li>
              <li>
                등록비 계좌이체 시, 입금자명과 등록자 명이 동일해야 확인 가능하며, 입금자명이 다를 경우 사무국으로 연락 주시기 바랍니다.{' '}
              </li>
              <li>결제가 완료되면 'Waiting for Payment' 에서 'Completed'로 변경됩니다.</li>
              <li>
                결제 방법을 변경 할 경우, 사무국 (
                <a href={'mailto:secretariat.kprs@innon.co.kr'} style={{ fontWeight: 'bold', color: 'blue' }}>
                  secretariat.kprs@innon.co.kr
                </a>
                ) 으로 문의 주시기 바랍니다.
              </li>
              <li>
                결제 완료 메일은 결제 후 3주 이내에 발송 될 예정이며, 완료메일을 받지 못하신 경우, 사무국 (
                <a href={'mailto:secretariat.kprs@innon.co.kr'} style={{ fontWeight: 'bold', color: 'blue' }}>
                  secretariat.kprs@innon.co.kr
                </a>
                ) 으로 문의 주시기 바랍니다.{' '}
              </li>
            </ul>
          </div>
          <div>
            <div style={{ height: '20px' }} />
          </div>
          {/* <Typography style={{ fontWeight: 'bold' }}>송금처</Typography> */}
          <Table>
            <TableBody>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  은행명
                </StyledTableCell>
                <StyledTableCell align="center">하나은행</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  계좌 번호
                </StyledTableCell>
                <StyledTableCell align="center">261-910022-59704</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center" component={'th'} style={{ backgroundColor: '#237a9d', color: '#fff' }}>
                  예금주
                </StyledTableCell>
                <StyledTableCell align="center">대한성형외과학회</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
          <div>
            <div style={{ height: '50px' }} />
          </div>
          <SubTitle>CME Credit for Korean Participants (평점안내)</SubTitle>
          {/* <div style={{ color: '#000000' }}>
            <ul className={classes.orderedList}>
              <li>준비중입니다.</li>
            </ul>
          </div> */}
          <Typography style={{ fontSize: '1.3em', lineHeight: 1.6 }}>
            <b>PRS KOREA 2022 평점기준안내</b>
            <br /> 평점 인정 기준을 아래와 같이 안내 드리오니 참고 부탁 드리며, 누락 후 사후 반영은 불가 하오니 사전에 숙지하여 주시기
            바랍니다.
          </Typography>
          <div style={{ color: '#000000', fontSize: '1.2em' }}>
            <ol className={classes.orderedList}>
              <li>평점안내</li>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      구분
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      11월 11일(금)
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      11월 12일(토)
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      11월 13일(일)
                    </StyledTableCell>
                    {/* <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      비고
                    </StyledTableCell> */}
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="center">대한의사협회</StyledTableCell>
                    <StyledTableCell align="center">6점 예정</StyledTableCell>
                    <StyledTableCell align="center">6점 예정</StyledTableCell>
                    <StyledTableCell align="center">6점 예정</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">필수평점</StyledTableCell>
                    <StyledTableCell align="center">-</StyledTableCell>
                    <StyledTableCell align="center">-</StyledTableCell>
                    <StyledTableCell align="center">2점 예정</StyledTableCell>
                    {/* <TableCell align="center">
                      11/14 Room 3 16:10~17:10 – 필수평점 강의 1<br />
                      11/14 Room 3 17:20~18:20 – 필수평점 강의 2
                    </TableCell> */}
                  </StyledTableRow>
                </TableBody>
              </Table>
              <li style={{ marginTop: '1em' }}>평점 인정 기준</li>
              <Table>
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      이수시간
                    </StyledTableCell>
                    <StyledTableCell
                      style={{ backgroundColor: '#237a9d', color: theme.palette.common.white, fontWeight: 'bold', textAlign: 'center' }}
                    >
                      인정평점
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell align="center">1시간 미만</StyledTableCell>
                    <StyledTableCell align="center" style={{ color: '#f00' }}>
                      평점인정불가
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">1시간 이상-2시간 미만</StyledTableCell>
                    <StyledTableCell align="center">1평점</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">2시간 이상-3시간 미만</StyledTableCell>
                    <StyledTableCell align="center">2평점</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">3시간 이상-4시간 미만</StyledTableCell>
                    <StyledTableCell align="center">3평점</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">4시간 이상-5시간 미만</StyledTableCell>
                    <StyledTableCell align="center">4평점</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">5시간 이상-6시간 미만</StyledTableCell>
                    <StyledTableCell align="center">5평점</StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow>
                    <StyledTableCell align="center">6시간 이상</StyledTableCell>
                    <StyledTableCell align="center">6평점</StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
              {/* <div>
                예시)
                <br />
                50분 이수 : 0평점
                <br />
                1시간 59분 이수 : 1평점
                <br />
                3시간 2분 이수 : 3평점
              </div> */}
            </ol>
          </div>
          <div>
            <div style={{ height: '50px' }} />
          </div>
          <SubTitle>Registration Confirmation</SubTitle>
          <div style={{ color: '#000000' }}>
            <ul className={classes.orderedList}>
              <li>등록 완료 후 등록 완료 메일은 등록하신 이메일로 발송 됩니다.</li>
              <li>입금 완료 메일은 입금이 완료되어야 발송이 되며, 미 입금 시 발송 되지 않습니다.</li>
            </ul>
          </div>
          <div>
            <div style={{ height: '50px' }} />
          </div>
          <SubTitle>Cancellation and Refund Policy</SubTitle>
          {/*<div style={{ textAlign: 'center', marginTop: '1em' }}>*/}
          {/*  <Button*/}
          {/*    variant="contained"*/}
          {/*    color="primary"*/}
          {/*    disableElevation*/}
          {/*    onClick={() => this.props.cancellationFormDownload()}*/}
          {/*    style={{ width: '200px', padding: '0.5em 0' }}*/}
          {/*  >*/}
          {/*    Cancellation Form Download*/}
          {/*  </Button>*/}
          {/*</div>*/}
          <div style={{ color: '#000000' }}>
            <ul className={classes.orderedList}>
              <li>
                등록 취소는 대한성형외과학회로 문의하시기 바랍니다. ( <b>Tel.</b>&nbsp;02-3472-4253, <b>E-mail:</b>&nbsp;
                <a href={'mailto:secretariat.kprs@innon.co.kr'}>kprs@plasticsurgery.or.kr</a>)
              </li>
              <li>등록비 환불 규정은 아래 참고하시기 바랍니다.</li>
            </ul>
          </div>
          <Table>
            <TableBody>
              <StyledTableRow>
                <TableCell
                  align="center"
                  component={'th'}
                  width="50%"
                  style={{
                    backgroundColor: '#265c7a',
                    borderRight: '0.5px solid #fff',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontSize: 'large',
                  }}
                >
                  일자
                </TableCell>
                <TableCell
                  align="center"
                  component={'th'}
                  style={{
                    backgroundColor: '#265c7a',
                    borderLeft: '0.5px solid #fff',
                    color: theme.palette.common.white,
                    fontWeight: 'bold',
                    fontSize: 'large',
                    textAlign: 'center',
                  }}
                >
                  등록비 환불
                </TableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">2022년 10월 31일까지</StyledTableCell>
                <StyledTableCell align="center">전액 환불</StyledTableCell>
              </StyledTableRow>
              <StyledTableRow>
                <StyledTableCell align="center">2022년 11월 1일부터</StyledTableCell>
                <StyledTableCell align="center">환불 불가</StyledTableCell>
              </StyledTableRow>
            </TableBody>
          </Table>
        </div>
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(RegistrationGuideEn);
